
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Vikhrolitopunecabservice() {



    const cardData =
    {
        keyword: ' Vikhroli to Pune Cab Services',
        heading: 'Skyline Cabs: Vikhroli to Pune Cab Services ',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Vikhroli to Pune Cab Services for a seamless intercity travel experience. Whether you are traveling for business, personal reasons, or a weekend getaway, our clean and well-maintained cabs driven by courteous professionals ensure a safe and smooth journey. With on-time pickups from Vikhroli, transparent pricing, and 24/7 customer support, Skyline Cabs is your dependable choice for hassle-free travel. Book your Vikhroli to Pune cab today and enjoy a relaxed and worry-free ride.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Vikhroli to Pune Cab",
    "description": "Skyline Cabs offers reliable and affordable taxi services from Vikhroli to Pune. We have a wide selection of vehicles, including sedans, SUVs, and luxury options to suit your preferences. Enjoy a comfortable and smooth ride with our experienced drivers, ensuring timely arrival and great service."
  },
  {
    "name": "Vikhroli to Pune One Way Cab",
    "description": "If you're looking for a one-way trip from Vikhroli to Pune, Skyline Cabs provides affordable one-way cab services. Enjoy the convenience of a direct ride with no detours. Choose from various vehicles, including sedans and SUVs, and travel in comfort and safety."
  },
  {
    "name": "Vikhroli to Pune Station Cab",
    "description": "Skyline Cabs offers taxi services from Vikhroli to Pune Station, ensuring you reach your destination on time. Our fleet of well-maintained vehicles offers comfort and reliability, with affordable pricing and no hidden fees."
  },
  {
    "name": "Vikhroli to Pimpri Chinchwad Cab",
    "description": "Travel from Vikhroli to Pimpri Chinchwad with Skyline Cabs. Our reliable and affordable services ensure a smooth journey, whether you're traveling for work or leisure. Book now for a comfortable ride with transparent pricing."
  },
  {
    "name": "Vikhroli to Wanwadi Cab",
    "description": "Skyline Cabs provides taxi services from Vikhroli to Wanwadi, ensuring a comfortable and hassle-free journey. Whether you're heading to Wanwadi for business or leisure, our fleet of well-maintained vehicles ensures a pleasant and timely trip."
  },
  {
    "name": "Vikhroli to Pune Innova Crysta Cab",
    "description": "For a premium ride from Vikhroli to Pune, choose our Innova Crysta cabs. With ample space, luxury interiors, and professional drivers, your journey will be comfortable and relaxing. Book your Innova Crysta today for a premium experience."
  },
  {
    "name": "Vikhroli to Pune 7 Seater Cab",
    "description": "Travel with family or friends in comfort with Skyline Cabs' 7-seater vehicles. From Vikhroli to Pune, our spacious 7-seater cabs offer plenty of room for passengers and luggage. Enjoy a comfortable, affordable ride tailored for group travel."
  },
  {
    "name": "Vikhroli to Pune Sedan Cab",
    "description": "For a more compact yet comfortable ride, Skyline Cabs offers sedan taxis from Vikhroli to Pune. Our sedan cabs are ideal for smaller groups or individuals seeking a quick, affordable, and comfortable journey. Book now for the best service."
  },
  {
    "name": "Vikhroli to Pune Shivaji Nagar Cab",
    "description": "Skyline Cabs provides comfortable and affordable taxi services from Vikhroli to Shivaji Nagar, Pune. With reliable vehicles and professional drivers, you can be sure of a smooth, stress-free journey to your destination."
  },
  {
    "name": "Vikhroli to Swargate Cab",
    "description": "Travel to Swargate from Vikhroli with Skyline Cabs' efficient and affordable taxi services. We offer reliable rides in well-maintained vehicles, ensuring you arrive at your destination comfortably and on time."
  },
  {
    "name": "Taxi Service in Vikhroli Mumbai",
    "description": "Skyline Cabs offers the best taxi services in Vikhroli, Mumbai. Whether you need a local ride or an outstation trip, our fleet of well-maintained vehicles ensures a safe and comfortable journey at affordable rates."
  },
  {
    "name": "Vikhroli to Viman Nagar Taxi Service",
    "description": "For a smooth ride from Vikhroli to Viman Nagar, choose Skyline Cabs. We offer affordable taxi services with a variety of vehicles to match your needs. Enjoy comfort, convenience, and transparency in pricing."
  },
  {
    "name": "Vikhroli Cabs Service",
    "description": "Skyline Cabs provides reliable and affordable cab services in Vikhroli. From local trips to outstation rides, our professional drivers and well-maintained vehicles ensure you have a comfortable journey every time."
  },
  {
    "name": "Outstation Cabs Taxi Service Mumbai",
    "description": "Skyline Cabs offers outstation taxi services from Mumbai to various destinations, including Pune, Lonavala, and more. With a wide range of vehicles and professional drivers, we ensure your outstation travel is comfortable, safe, and affordable."
  }
],
"tableData": [
  ["Vikhroli to Pune Cab", "Vikhroli to Pune One Way Cab"],
  ["Vikhroli to Pune Station Cab", "Vikhroli to Pimpri Chinchwad Cab"],
  ["Vikhroli to Wanwadi Cab", "Vikhroli to Pune Innova Crysta Cab"],
  ["Vikhroli to Pune 7 Seater Cab", "Vikhroli to Pune Sedan Cab"],
  ["Vikhroli to Pune Shivaji Nagar Cab", "Vikhroli to Swargate Cab"],
  ["Taxi Service in Vikhroli Mumbai", "Vikhroli to Viman Nagar Taxi Service"],
  ["Vikhroli Cabs Service", "Outstation Cabs Taxi Service Mumbai"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Vikhroli to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and timely cab services from Vikhroli to Pune. Whether you are traveling for business, leisure, or any other reason, we ensure a smooth, comfortable, and punctual journey every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes a range of well-maintained vehicles, from sedans to spacious SUVs. All vehicles are air-conditioned, ensuring that your ride from Vikhroli to Pune is comfortable, relaxing, and enjoyable."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced professionals, familiar with the best routes from Vikhroli to Pune. They prioritize safety, comfort, and punctuality, ensuring that your journey is smooth and hassle-free."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you get clear, upfront pricing for your Vikhroli to Pune ride. We offer competitive pricing with no hidden charges, giving you great value for your money."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "We operate 24/7, allowing you to book a cab from Vikhroli to Pune at any time, whether it’s early in the morning or late at night. We are always ready to assist you with your travel needs."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your cab is simple and quick with Skyline Cabs. You can use our website or mobile app to book a ride in just a few clicks, with instant booking confirmation and real-time tracking for your convenience."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Your health and safety are our top priorities. All of our vehicles are thoroughly sanitized before each ride, and our drivers adhere to strict hygiene protocols, ensuring that you travel in a clean, safe, and hygienic environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Whether you're traveling alone, with family, or in a group, Skyline Cabs has the perfect vehicle for your needs. From comfortable sedans to larger SUVs, we offer a variety of vehicles for your journey from Vikhroli to Pune."
    }
]





















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Vikhroli to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Vikhroli to Pune is quick and hassle-free. You can book through our website, mobile app, or by calling our customer support team. Just enter your pickup and drop-off locations, choose a vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Vikhroli to Pune trip?',
            answer:
                'Skyline Cabs offers various vehicle options including Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. Choose the one that fits your comfort and group size needs.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Vikhroli to Pune?',
            answer:
                'The journey from Vikhroli to Pune usually takes between 3.5 to 5 hours, depending on traffic. Our drivers ensure efficient and smooth travel.',
        },
        {
            id: 4,
            question: 'Are the fares for Vikhroli to Pune cab fixed?',
            answer:
                'Yes, we offer fixed fares that include tolls, taxes, and driver charges. You’ll get complete pricing details upfront with no hidden fees.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Vikhroli to Pune?',
            answer:
                'Yes, you can easily schedule a round-trip while booking. Just mention your return time and date, and we’ll take care of the rest.',
        },
        {
            id: 6,
            question: 'Can I change or cancel my Vikhroli to Pune booking?',
            answer:
                'Of course. You can make changes or cancel your booking anytime via our website, app, or customer support. We offer flexible options for your convenience.',
        },
        {
            id: 7,
            question: 'Are the cabs from Vikhroli to Pune clean and safe?',
            answer:
                'Absolutely. All our cabs are well-maintained, regularly serviced, and thoroughly cleaned to ensure a comfortable and safe journey.',
        },
        {
            id: 8,
            question: 'What payment options do I have for the Vikhroli to Pune ride?',
            answer:
                'You can pay online using UPI, credit/debit cards, or net banking. We also accept cash at the end of your ride if that’s more convenient for you.',
        },
        {
            id: 9,
            question: 'Do you offer corporate cab services from Vikhroli to Pune?',
            answer:
                'Yes, Skyline Cabs provides corporate travel solutions for business trips, meetings, and group transport from Vikhroli to Pune. Get in touch with us for custom packages.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Vikhroli to Pune journey?',
            answer:
                'Skyline Cabs stands out for its reliable service, professional drivers, well-maintained vehicles, and transparent pricing. We ensure a comfortable, safe, and punctual ride every time.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I took a cab from Vikhroli to Pune and the experience was fantastic. Driver was on time, car was clean, and the ride was smooth. Definitely using Skyline again!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Comfortable trip from Vikhroli to Pune. Booking was easy and the support team was responsive. A bit of traffic, but the driver managed the route well."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vikhroli to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/vikhroli-to-pune-cab.jpg",
  "description": "Book Vikhroli to Pune cab with Skyline Cabs for a convenient, reliable, and affordable ride. 24/7 AC sedan and SUV cab service available with verified drivers for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7346"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/vikhroli-to-pune-cab"
  }
};



      
      


    return (
        <div>

<Helmet>
  <title>Vikhroli to Pune Cab | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Vikhroli to Pune cab with Skyline Cabs for a convenient, reliable, and affordable ride. 24/7 AC sedan and SUV cab service available with verified drivers for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Vikhroli to Pune Cab, Cab from Vikhroli to Pune, One-Way Taxi Vikhroli to Pune, Round Trip Cab Vikhroli to Pune, AC Cab Vikhroli to Pune, SUV Taxi Vikhroli to Pune, Affordable Taxi Vikhroli to Pune, Skyline Cabs Vikhroli to Pune, Online Cab Booking Vikhroli to Pune, 24/7 Taxi Vikhroli to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/53.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Vikhrolitopunecabservice;